import Vue from "vue";
import Vuex from "vuex";
import vMediaQuery from "v-media-query";
import createPersistedState from "vuex-persistedstate";
import VueHead from "vue-head";

import auth from "./modules/auth";
import api from "./modules/api";
import users from "./modules/users";
import companyUsers from "./modules/companyUsers";
import apps from "./modules/apps";
import appLicenses from "./modules/appLicenses";
import appLicenseGroups from "./modules/appLicenseGroups";
import briefs from "./modules/briefs";
import permissions from "./modules/permissions";
import groups from "./modules/groups";
import alerts from "./modules/alerts";
import issues from "./modules/issues";
import recognitions from "./modules/recognitions";
import ui from "./modules/ui";
import upload from "./modules/upload";
import reports from "./modules/reports";
import companies from "./modules/companies";
import products from "./modules/products";

import modules from "./modules/modules";
import courses from "./modules/courses";
import programs from "./modules/programs";

import surveys from "./modules/surveys";
import panels from "./modules/panels";
import splashPages from "./modules/splashPages";

Vue.use(Vuex);
Vue.use(VueHead);
Vue.use(vMediaQuery);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "myethosadmin",
      paths: [
        "auth.token",
        "auth.activeRoleId",
        "auth.activeCompany",
        "ui.sidenavCollapsed"
      ]
    })
  ],
  strict: debug,
  modules: {
    api,
    auth,
    users,
    companyUsers,
    apps,
    appLicenses,
    appLicenseGroups,
    briefs,
    permissions,
    groups,
    alerts,
    issues,
    recognitions,
    ui,
    companies,
    upload,
    reports,
    surveys,
    products,
    modules,
    courses,
    programs,
    panels,
    splashPages
  }
});
